const heroToSliderEl = document.querySelector('.hero-slider');

if (heroToSliderEl) {
  let autoplay = false;
  if (heroToSliderEl.dataset.autoplay != null) {
    autoplay = {
      delay: Number(heroToSliderEl.dataset.autoplay),
    }
  }

  const heroToSlider = new Swiper(heroToSliderEl, {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    autoplay,
    pagination: {
      el: heroToSliderEl.querySelector('.swiper-pagination'),
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
    }
  });
}